import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import styles from './Drawer.module.scss';
import { DrawerToggleState } from '../models/actionStates';
import { useRecoilState, useRecoilValue } from 'recoil';
import { cartDrawerState, isDesktopState } from '../recoil/selectors';
import { abTestState } from '../recoil/atoms';

interface Props {
  isVisible: boolean;
  zIndex?: number;
  backgroundColor?: string;
  height?: string;
  width?: string;
  minHeight?: string;
  minWidth?: string;
  maxHeight?: string;
  maxWidth?: string;
  lockViewport?: boolean;
}

export const Drawer: React.FC<Props> = ({
  isVisible,
  children,
  zIndex,
  backgroundColor,
  height,
  width,
  minWidth,
  minHeight,
  maxWidth,
  maxHeight,
  lockViewport,
}) => {
  const [cartDrawer, setCartDrawer] = useRecoilState(cartDrawerState);
  const [drawerHeight, setDrawerHeight] = useState<string | undefined>(height);
  const [drawerMaxHeight, setDrawerMaxHeight] = useState<string | undefined>(maxHeight);
  const abTests = useRecoilValue(abTestState);
  const isDesktop = useRecoilValue(isDesktopState);

  useEffect(() => {
    if (lockViewport) {
      setDrawerHeight('100vh');
      setDrawerMaxHeight('100vh');
      isVisible ? document.body.classList.add('cart-drawer-open') : document.body.classList.remove('cart-drawer-open');
    }
  }, [abTests, lockViewport, isVisible]);
  return (
    <div
      className={classnames(styles.drawerContainer, { [styles.open]: isVisible })}
      style={{ zIndex: zIndex ?? 10000, height: drawerHeight ?? undefined, maxHeight: drawerMaxHeight ?? undefined }}
      onClick={(e) => {
        if (e.currentTarget === e.target) {
          setCartDrawer({ ...cartDrawer, toggleState: DrawerToggleState.Closed });
        }
      }}
      role="none" // will remove the semantic meaning of an element while still exposing it to assistive technology.
    >
      <div
        className={styles.drawer}
        style={{
          backgroundColor: backgroundColor ?? undefined,
          height: drawerHeight ?? '100%',
          width: width ?? undefined,
          minWidth: minWidth ?? '0',
          minHeight: minHeight ?? '0',
          maxWidth: maxWidth ?? '100%',
          maxHeight: drawerMaxHeight ?? '100%',
          overflowY: lockViewport ? 'hidden' : 'auto',
        }}
        role="dialog"
        aria-label="Drawer"
      >
        {children}
      </div>
    </div>
  );
};

export default Drawer;
